export default function humanizeNumber(number){
  number = Math.floor(number || 0)
  if (number < 1000) return `${number}`
  let toFixed = n => n.toFixed(1).replace('.0', '')
  if (number < 1000000)
    return `${toFixed(number / 1000)}K`
  return `${toFixed(number / 1000000)}M`
}
